import React, { useState } from 'react'
import Pagination from '../../Pagination/Pagination'
import { Grid } from '@material-ui/core'
import MachineCard from '../MachineCard'

const MachineGrid = ({
  machines,
  setMachineToEdit,
  setShowAddEditMachine,
  setMachineToDelete,
  setShowDeleteModal,
}) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)

  return (
    <>
      <Grid container spacing={2}>
        {(rowsPerPage > 0
          ? machines.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          : machines
        ).map((machine, index) => (
          <Grid key={index} item xs={3}>
            <MachineCard
              machine={machine}
              setMachineToEdit={setMachineToEdit}
              setShowAddEditMachine={setShowAddEditMachine}
              setMachineToDelete={setMachineToDelete}
              setShowDeleteModal={setShowDeleteModal}
            />
          </Grid>
        ))}
      </Grid>

      <Pagination
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        rows={machines}
        className="m-t-40"
      />
    </>
  )
}

export default MachineGrid
